import { Component } from "@angular/core";

@Component({
  selector: "close-dialog-cross-icon-svg",
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol id="closeDialogCrossIcon" viewBox="0 0 12 12" fill="none">
        <g clip-path="url(#clip0_1051_41)">
          <path
            d="M9.375 2.625L2.625 9.375"
            stroke="#2D343F"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.375 9.375L2.625 2.625"
            stroke="#2D343F"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1051_41">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </symbol>
    </svg>
  `,
})
export class CloseDialogCrossIconSvgComponent {}
